<ion-header>
    <ion-toolbar>
        <ion-title>
            Sportler
        </ion-title>
        <ion-buttons slot="end">
            <ion-button fill="clear" (click)="viewCtrl.dismiss()">
                <ion-icon name="close" color="primary"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content>
        <div class="container">
            <div class="list-container">
                <ion-list class="list-block">
                    <ion-item class="item-block">
                        <ion-label class="label-block" position="stacked" >Name:</ion-label>
                        <ion-input [(ngModel)]="player.name"></ion-input>
                    </ion-item>
                    <ion-item class="item-block">
                        <ion-label style="min-width: 80px" class="label-block" position="stacked">Teams:</ion-label>
                        <ion-select [ngClass]="{'arrowcheck': !gs.planList[activePlan]?.teams.length}" class="combi" (ionChange)="activeTeam = $any($event.target).value">
                            <ion-select-option *ngFor="let team of gs.planList[activePlan]?.teams; let i = index" [value]="i">
                                {{ team.name }}
                            </ion-select-option>
                        </ion-select>
                        <ion-input class="input-inside" style="margin-left: 90px" [(ngModel)]="activePlanList"></ion-input>
                    </ion-item>
                    <ion-item class="item-block" *ngIf="gs.planList.length">
                        <ion-label style="min-width: 80px" class="label-block" position="stacked">Spielplan:</ion-label>
                        <ion-select class="combi" (ionChange)="activePlan = $any($event.target).value">
                            <ion-select-option *ngFor="let plan of gs.planList; let i = index" [value]="i">
                                {{ plan.name }}
                            </ion-select-option>
                        </ion-select>
                        <ion-input class="input-inside" style="margin-left: 90px" [(ngModel)]="activePlanName"></ion-input>
                    </ion-item>
                    <ion-item class="item-block">
                        <ion-label class="label-block" position="stacked">{{ 'GLOBAL_NUMBER' | translate }}:</ion-label>
                        <ion-input class="input-block" [(ngModel)]="player.memo">
                        </ion-input>
                    </ion-item>
                    <ion-item class="content-end">
                        <ion-select placeholder="{{ types[player?.type] }}" (ionChange)="onValueChange('type', $event)"
                            multiple="false">
                            <ion-option *ngFor="let type of types; let i = index" [value]="i">
                                {{ type }}
                            </ion-option>
                        </ion-select>
                    </ion-item>
                    <ion-item class="content-end">
                        <ion-select placeholder=" {{ styles[player?.style] }}" (ionChange)="onValueChange('style', $event)"
                            multiple="false">
                            <ion-select-option *ngFor="let style of styles; let i = index" [value]="i">
                                {{ style }}
                            </ion-select-option>
                        </ion-select>
                    </ion-item>
                    <ion-item>
                        <input class="circle-input" type="color" id="colorWell1" name="head"
                            value="{{ player.color1 }}" (change)="onColorSelect($any($event.target).value, 0);">
                        <!-- <span item-end> {{ 'COLOR_ONE' | translate}}</span> -->
                        <ion-label>{{ 'COLOR_ONE' | translate }}</ion-label>
                    </ion-item>
                    <ion-item *ngIf="!(player?.style == style.colored)">
                        <input class="circle-input" type="color" id="colorWell2" name="head"
                            (change)="onColorSelect($any($event.target).value, 1);" value="{{ player.color2 }}">
                        <!-- <span item-end> {{ 'COLOR_TWO' | translate}}</span> -->
                        <ion-label>{{ 'COLOR_TWO' | translate }}</ion-label>
                    </ion-item>
                </ion-list>
            </div>

            <div class="tshirt-block">
                <svg-tshirt-container [type$]="player?.type" [style$]="player?.style" class="tshirt-image"></svg-tshirt-container>
                <div class="tshirt-description">
                    <div class="name">{{ player.name }}</div>
                    <div class="memo">{{ player.memo }} </div>
                </div>
            </div>

            <div class="buttons-group">
                <ion-button class="btn-submit" expand="block"  color="secondary" (click)="onAddPlayer()" *ngIf="!isExists()">{{ 'GLOBAL_ADD' | translate }}</ion-button>
                <ion-button class="btn-submit" expand="block"  color="secondary" (click)="onEditPlayer()" *ngIf="isExists()">{{ 'GLOBAL_EDIT' | translate }}</ion-button>
                <ion-button *ngIf="team" class="btn-submit" expand="block"  color="secondary" (click)="onDeletePlayer()">{{ 'GLOBAL_DELETE' | translate }}</ion-button>
            </div>

        </div>
</ion-content>